/**
 * 라우트 전환 시 이전 화면에서 시작된 apiClient(axios) 요청을 중단하기 위한 AbortSignal.
 * Firestore 등 비-http 요청에는 적용되지 않음.
 */

let navigationAbortController = new AbortController();

function combineAbortSignals(...signals) {
  const valid = signals.filter(Boolean);
  if (valid.length === 0) return undefined;
  if (valid.length === 1) return valid[0];
  if (typeof AbortSignal !== "undefined" && typeof AbortSignal.any === "function") {
    return AbortSignal.any(valid);
  }
  const merged = new AbortController();
  valid.forEach((sig) => {
    if (sig.aborted) {
      merged.abort();
      return;
    }
    sig.addEventListener("abort", () => merged.abort(), { once: true });
  });
  return merged.signal;
}

/**
 * 현재 라우트 "세대"에 해당하는 signal. apiClient 요청 인터셉터에서 기본 부착.
 */
export function getNavigationAbortSignal() {
  return navigationAbortController.signal;
}

/**
 * 라우트가 바뀔 때 호출: 진행 중이던 요청에 abort를 보내고 새 Controller를 만든다.
 */
export function rotateNavigationAbortController() {
  navigationAbortController.abort();
  navigationAbortController = new AbortController();
  return navigationAbortController.signal;
}

/**
 * 요청별로 이미 넘긴 signal과 네비게이션 signal을 합친다.
 */
export function mergeWithNavigationSignal(existingSignal) {
  return combineAbortSignals(getNavigationAbortSignal(), existingSignal);
}
